<template>
    <card-seplag :titulo="nomeCard">
        <div class="p-col-12 p-component p-fieldset" style="margin-bottom: 1%;">            
            <div class="p-grid" style="padding-left: 1%;">                
                <div class="p-col-1 col-imagem">
                    <i class="pi pi-user iconIdentificacaoForm"></i>
                </div>
                <div class="p-col-md-11 p-col-sm-12" style="margin-top: 1%;">
                    <p><strong>{{ dadosPessoa.nome }}</strong></p>
                    <p><strong>Matrícula:</strong> {{ dadosPessoa.matricula }}</p>
                    <p><strong>CPF:</strong> {{ dadosPessoa.cpf }}</p>
                    <p><strong>RG:</strong> {{ dadosPessoa.rg }}</p>
                </div>
            </div>
        </div>     
        <Rotulo nome="Email:" cols="12 3" requerido>
            <InputText type="text" id="descEmail" v-model="solicitacaoVerbaRec.descEmail" disabled />
        </Rotulo>
        <Rotulo nome="Contato com WhatsApp" cols="12 2" requerido>
            <InputMask id="descTelefoneWhatsapp" mask="(99)9 9999-9999" placeholder="(99)9 9999-9999" v-model="solicitacaoVerbaRec.descTelefoneWhatsapp" disabled/>
        </Rotulo>
        <Rotulo nome="Contato" cols="12 2">
            <InputMask id="descTelefone" mask="(99)9 9999-9999" placeholder="(99)9 9999-9999" v-model="registro.descTelefone" disabled/>
        </Rotulo>
        <Divider class="p-col-12" style="border: 1px solid #d5d5d5;"/>   
        <h3 class="p-col-12">DADOS BANCÁRIOS PARA PAGAMANETO:</h3>
        <Rotulo nome="Banco:" cols="12 4" requerido>
            <InputText type="text" id="conta" v-model="dadosBancarios.banco" disabled />
        </Rotulo>    
        <Rotulo nome="Agencia:" cols="12 4" requerido>
            <InputText type="text" id="agencia" v-model="dadosBancarios.agencia" disabled />
        </Rotulo>
        <Rotulo nome="Conta:" cols="12 4" requerido>
            <InputText type="text" id="conta" v-model="dadosBancarios.conta" disabled />
        </Rotulo> 
        <Divider class="p-col-12" style="border: 1px solid #d5d5d5;"/>   
            <div class="p-col-12" style="padding-left: 1%;">        
                <DataTable
                    :value="solicitacaoVerbaRec.solicitacaoVerbaProcessoList"
                    class="p-col-12 p-datatable-responsive"
                >
                <Column
                    field="descProcesso"
                    header="Processo"
                    :bodyStyle="{'text-align': 'center'}"
                    :headerStyle="{textAlign: 'center',width: '15%'}"
                ></Column>
                <Column
                    field="dataCitacao"
                    header="Data Citação"
                    :headerStyle="{textAlign: 'center',width: '7%'}"
                ></Column>
                <Column
                    field="flagRecebeuValor"
                    header="Já recebeu valor ou já esta definido?"
                >
                <template #body="slotProps">
                    {{ slotProps.data.flagRecebeuValor == 'S'? "Sim" : "Não" }}
                </template>
                </Column>
                <Column
                    field="descObjetoAcao"
                    header="Objeto da Acao"
                ></Column>
                <Column
                    field="anoVinculo"
                    header="Ano/Vinculo"
                >
                    <template #body="slotProps">
                        {{ slotProps.data.anoVinculo && slotProps.data.anoVinculo.length>0?slotProps.data.anoVinculo.join(', '): ""}}
                    </template>
                </Column>
                <Column
                    field="valrRecebido"
                    header="Valor"
                    :bodyStyle="{'text-align': 'center'}"
                >
                    <template #body="slotProps">
                        {{ slotProps.data.valrRecebido?  slotProps.data.valrRecebido.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }): "Não Informado" }}
                    </template>
                </Column>
                </DataTable>
            </div>             
        <Divider class="p-col-12" style="border: 1px solid #d5d5d5;"/>        
        <Rotulo nome="Descrição Despacho" cols="12" requerido>
            <Textarea v-model="registro.descDespacho" rows="5" cols="30" disabled/>
        </Rotulo>
        <div class="p-col-12 p-grid" style="margin-top: 10px;">  
            <div class="p-col-12 p-md-4" style="display: flex; align-items: center;">
                <Rotulo nome="Valor total:" cols="12 6">
                    <InputNumber id="valorCalculadoFinal" v-model="valorCalculadoFinal" mode="currency" currency="BRL" disabled/>
                </Rotulo>
                <Button icon="pi pi-print" v-tooltip="'Ver o extrato do Calculo'"  style="margin-top: 13px;"  @click="abrirRelatorioCalculo()"/>
            </div>
        </div>
        <div class="p-col-12 p-grid" style="margin-top: 10px;">
          <div class="p-col-12 p-md-4" style="display: flex; align-items: center;">
            <!-- DESCOMENTAR CASO VA UTILIZAR A FUNCIONALIDADE DE PARTICIPACAO ADVOGADO
            <Rotulo nome="Você tem processo judicial em curso sobre esse tema? Se sim, você tem interesse em destacar os honorários contratuais do seu advogado?" cols="12 20">
              <Checkbox id="possuiAdvogado" v-model="possuiAdvogado" :binary="true"/>
            </Rotulo>
            -->
            <Rotulo nome="Porcentagem de 1 a 50% de desconto do valor a receber para advogado." cols="12 6" v-if="possuiAdvogado">
              <InputNumber v-model="percentage"
                            :min="1"
                           :max="50"
                           @input="validatePercentage"
                           :formatter="formatPercentage"
                           :parser="parsePercentage"></InputNumber>
            </Rotulo>
          </div>
        </div>
        <Rotulo nome="Indique os números dos processos judiciais sobre o tema" cols="12 20" v-if="possuiAdvogado"></Rotulo>
          <Button label="Adicionar processo" class="p-button-success" style="margin-left: 2px;" @click="acionarModalAdicionarNumeroProcesso()" v-if="possuiAdvogado"/>
          <DataTable
              :value="listaNumeroProcesso"
              class="p-col-12 p-datatable-responsive"
              scrollHeight="flex"
              :scrollable="true"
              responsiveLayout="scroll" dataKey="idenSolicitacaoValorVinculo"
              v-if="possuiAdvogado"
              style="max-height: 250px; overflow-y: auto;">
            <Column
                field="numero"
                header="Número do processo"
                :bodyStyle="'text-align:center'"
            ></Column>
            <Column
                header="Ação"
                :bodyStyle="'text-align:center'"
                :headerStyle="'width: 7%;'"
            >
              <template #body="slotProps">
                <Button
                    type="button"
                    icon="pi pi-times"
                    class="p-button-rounded p-button-danger"
                    v-tooltip.top="'Remover'"
                    style="color: white;"
                    @click="removerNumeroProcesso(slotProps.data.indice)"
                    :disabled="naoPodeEditar"
                />
              </template>
            </Column>
          </DataTable>

        <Dialog header="Incluir número de processo" :visible.sync="modalAdicionarNumeroProcesso" :containerStyle="{width: '50vw'}" contentStyle="overflow-y: unset" :modal="true">
          <div class="p-grid">
            <Rotulo nome="Numero do Processo:" cols="12 3">
              <InputText  id="descProcesso" placeholder="XXXXXX-XX.ANO.8.11.XXXX" v-model="numeroProcesso" :disabled="naoPodeEditar"  @input="applyMask"/>
            </Rotulo>
          </div>
          <template #footer>
            <Button label="Cancelar" icon="pi pi-times" @click="acionarModalAdicionarNumeroProcesso" class="p-button-text"/>
            <Button label="Salvar" icon="pi pi-save" @click="adicionarNumeroProcesso" autofocus />
          </template>
        </Dialog>

        <Divider class="p-col-12" style="border: 1px solid #d5d5d5;"/>
        <Rotulo nome="Proposta de Pagamento do Valor Total Calculado Final:" cols="12" requerido v-if="!possuiAdvogado">
            <DataTable :value="listaPropostaDespacho" :selection.sync="propostaSelecionada" responsiveLayout="scroll" dataKey="idenSolicitacaoDespachoPro">
                <Column selectionMode="single" :headerStyle="{'width': '3em'}"></Column>
                <Column field="descDespachoPro" header="Descrição"></Column>
                <Column field="valrDespachoPro" header="Valor a Receber">
                    <template #body="slotProps">
                        {{ slotProps.data.valrDespachoPro.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}}
                    </template>
                </Column>
            </DataTable>
        </Rotulo>
        <Rotulo nome="Proposta de Pagamento do Valor Total Calculado Final:" cols="12" requerido v-if="possuiAdvogado">
          <DataTable :value="listaPropostaDespacho" :selection.sync="propostaSelecionada" responsiveLayout="scroll" dataKey="idenSolicitacaoDespachoPro">
            <Column selectionMode="single" :headerStyle="{'width': '3em'}"></Column>
            <Column field="descDespachoPro" header="Descrição"></Column>
            <Column field="valrDespachoPro" header="Valor a Receber">
              <template #body="slotProps">
                {{ slotProps.data.valrDespachoPro.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}}
              </template>
            </Column>
            <Column field="descontoAdvogado" header="Desconto do advogado">
              <template #body="slotProps">
                {{ (slotProps.data.valrDespachoPro * percentage / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}}
              </template>
            </Column>
            <Column field="valrDespachoProComDescontoAdvogado" header="Valor a Receber com desconto do advogado">
              <template #body="slotProps">
                {{ (slotProps.data.valrDespachoPro - (slotProps.data.valrDespachoPro * percentage / 100)).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}}
              </template>
            </Column>
          </DataTable>
        </Rotulo>
      <Divider class="p-col-12" style="border: 1px solid #d5d5d5;"/>
        <div class="p-col-12 p-md-3 divBotoesFinais">
            <Button label="Voltar" icon="pi pi-arrow-left" @click="voltarParaLista" class="p-button-text"/>      
            <Button label="Recusar" class="p-button-danger" icon="pi pi-times" style="margin-left: 2px;" @click="recurarValores()" />       
            <Button label="Aceitar" class="p-button-success" icon="pi pi-check" style="margin-left: 2px;" @click="aceitarValores()" />
        </div>
        <Dialog :showHeader="false"  :visible.sync="visualizarModalAceito" maximizable :containerStyle="{ width: '100vw !important', maxHeight: '100%', height: '100%', transition: 'none', transform: 'none'}" contentStyle="width: 100% !important;height: 100% !important;" :modal="true"> 
            <div class="p-grid">
                <div class="p-col-12" style="border: 1px solid gray; margin-bottom: 5px;">
                    <div style="padding: 5px; font-size: large; line-height: 1.5;">
                        <p>Estou ciente de que a aceitação da transação implica:</p>
                        <p style="margin-left: 10px;"><b>a)</b> aceitação plena, de forma irretratável e irrevogável, de todas as condições consubstanciadas no termo de transação e no Edital de Transação por Adesão nº 001/SEPLAG/SEDUC/PGE/MT;</p>
                        <p style="margin-left: 10px;"><b>b)</b> ampla e total quitação de todos os débitos objeto do presente termo, não havendo mais  nada a reclamar judicial ou administrativamente relativamente aos vínculos e anos descritos na proposta:</p>
                        <p style="margin-left: 15px;"><b>Proposta Selecionada:</b> {{ propostaSelecionada? propostaSelecionada.descDespachoPro :"" }}</p>
                        <DataTable
                            :value="listaValorCalculado"
                            class="p-col-12 p-md-8 p-datatable-responsive"
                            responsiveLayout="scroll" 
                            style="overflow-y: scroll;max-height: 400px;margin-left: 15px;"
                        >
                            <Column
                                field="descricaoAnoVinculo"
                                header="Ano/Vinculo"
                                :bodyStyle="'text-align:center'"
                            ></Column>
                            <Column
                                field="valorTotalCorrigido"
                                header="Valor Total"
                                :bodyStyle="'text-align:center'"
                            >
                                <template #body="slotProps">
                                    {{ slotProps.data.valorTotalCorrigido!=null? slotProps.data.valorTotalCorrigido.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }): "Não Calculado"}}
                                </template>
                            </Column>
                        </DataTable>
                        <p style="margin-left: 15px;"><b>Valor a Receber:</b> {{ propostaSelecionada? propostaSelecionada.valrDespachoPro.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }): "R$ 00,00" }} </p>
                        <p style="margin-left: 15px;" v-if="possuiAdvogado"><b>Desconto do advogado:</b> {{ descontoAdvogado? descontoAdvogado.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }): "R$ 00,00" }} </p>
                        <p style="margin-left: 15px;" v-if="possuiAdvogado"><b>Valor a Receber com desconto do advogado:</b> {{ valorComDescontoAdvogado? valorComDescontoAdvogado.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }): "R$ 00,00" }} </p>
                        <p style="margin-left: 10px;"><b>c)</b> concordância com a extinção parcial ou total das ações judiciais e dos cumprimentos de sentença porventura existentes para a cobrança dos valores reconhecidos no termo de  transação, em razão de sua integral satisfação;</p>
                        <p style="margin-left: 10px;"><b>d)</b> na minha responsabilidade pelo pagamento de eventuais custas judiciais remanescentes, se for o caso;</p>
                        <p style="margin-left: 10px;"><b>e)</b> na não abrangência de eventuais honorários contratuais em razão de contrato celebrado com advogado, se houver, comprometendo-me a adimplir tais verbas no modo contratualizado, sem qualquer ônus para o Estado.</p>
                        <p><b>EM CASO DE ACEITE, A SOLICITAÇÃO DEVE SEGUIR PARA PAGAMENTO.</b></p>
                    </div>
                </div>
                <div class="p-col-12 p-grid">
                    <Rotulo cols="12 2" nome="Login:">
                        <InputText type="text"  v-model="login"/>
                    </Rotulo>
                    <Rotulo cols="12 2" nome="Senha:">
                        <Password v-model="senha"  :feedback="false" :toggleMask="true"/>
                    </Rotulo>                    
                </div>  
            </div>  
            <template #footer>
                <Button label="Fechar" icon="pi pi-times" @click="fecharModal" class="p-button-text"/>
                <Button label="Aceitar" icon="pi pi-check" class="p-button-success" @click="aceitarProposta" autofocus/>
            </template>
        </Dialog>
        
        <Dialog header="Recusa de proposta" :visible.sync="visualizarModalRecusa" :containerStyle="{width: '30vw'}" :modal="true">
            <div class="confirmation-content">
                <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
                <span>Você tem certeza de que deseja recusar a proposta? 
                    Se sim, por favor, insira seu login e senha para validar a sua ação. 
                    <strong>Lembre-se de que, ao recusar, não haverá outra possibilidade de solicitar novamente, exceto judicialmente.</strong></span>
                <div class="p-col-12 p-grid" style="margin-top: 3%;">
                    <Rotulo cols="12 6" nome="Login:">
                        <InputText type="text"  v-model="login"/>
                    </Rotulo>
                    <Rotulo cols="12 6" nome="Senha:">
                        <Password v-model="senha"  :feedback="false" :toggleMask="true"/>
                    </Rotulo>                    
                </div>  
            </div>
            <template #footer>
                <Button label="Fechar" icon="pi pi-times" @click="fecharModal()" class="p-button-text"/>
                <Button label="Recusar" icon="pi pi-check" @click="recusarProposta()" class="p-button-text" autofocus />
            </template>
        </Dialog>
        
        <CardExibirPDF
        v-if="pdfElement && navegador != 'Safari'"
        v-model="exibirPDF"
        :nomeDocumento="nomeDocumentoPDF"
        :tituloTela="'PDF do Extrato do Calculo'"
        :position="'top'"
        :tamanhoTela="'55.em'"
        :alturaTela="'55.em'"
        :pdfElement="pdfElement"
        />
  </card-seplag>
</template>

<script>
import CardSeplag from "@/template/CardSeplag.vue";
import Rotulo from "@/template/RotuloSeplag.vue";
import { baseApiUrl } from "@/config/global";
import CardExibirPDF from "@/template/CardExibirPDF.vue";
const getNovoForm = () => {
    return {
    descDespacho: "",
    solicitacaoVerbaRescisoria: null,
    solicitacaoDespachoPropostaList: [],
    valorTotalDevido: 0
    }
}
const getNovoValor = () => {
    return {
        descricaoMotivoAlteracaoValor: null,
        descricaoAnoVinculo: "",
        valorTotalDevido:0,
        valorTotalEfetivo:0
    }
}
export default {
    name: "solicitaVerbaValidaDespacho",
    components: { CardSeplag, Rotulo, CardExibirPDF },
    data() {
        return {
            modo:"NOVO",
            naoPodeEditar: false,
            visualizarModalAceito: false,
            visualizarModalRecusa: false,
            dadosPessoa: {
                    matricula: null,
                    vinculo: null,
                    cpf: null,
                    nome: null,
                    cpfFormatado:null,
            },
            login:"",
            senha:"",
            idenSolicitacao: null,
            idenVinculo: null,
            valorCalculado: 0,            
            valorCalculadoFinal:0,
            possuiAdvogado: false,
            percentage: 1,
            descricaoPercentage: null,
            descontoAdvogado: 0,
            valorComDescontoAdvogado: 0,
            listaValorCalculado: [],
            listaPropostaDespacho: [],
            propostaSelecionada: null,
            nomeCard:"Validação do Despacho de Verba Idenizatória",
            registro: getNovoForm(),
            valorselecionado: getNovoValor(),
            solicitacaoVerbaRec: {
                descEmail: "",
                descTelefoneWhatsapp: "",
                flagPossuiProcesso:null,
                solicitacaoVerbaProcessoList: [],
                solicitacaoDespachoProposta: []
            },
            listaMotivo: [
                {code: "PROC_ENCONTRADO", name:"PROCESSO ENCONTRADO"},
                {code: "VALOR_DIVERGENTE", name:"VALOR DIVERGENTE"},
            ],
            dadosBancarios:{
                agencia:"",
                conta:"",
                banco:""
            },
            listaNumeroProcesso: [],
            numeroProcesso: null,
            modalAdicionarNumeroProcesso: false,
            exibirPDF: false,
            nomeDocumentoPDF: "Extrato do Calculo",
            pdfElement: null,
            navegador: null,
        }
    },
    methods: {
        applyMask() {
          let value = this.numeroProcesso.replace(/\D/g, ''); // Remove tudo que não é número
          if(value.length == 16 && value[15]==1 && value[14]==1 && value[13]==8){
            value = value.slice(0, 12);
          }
          // Aplica as partes da máscara manualmente
          if (value.length > 12 && value[15]==1 && value[14]==1 && value[13]==8) {
            value = value.slice(0, 7) + '-' + value.slice(7, 9) + '.' + value.slice(9, 13) + '.8.11.' + value.slice(16, 20);
          } else if (value.length > 12) {
            value = value.slice(0, 7) + '-' + value.slice(7, 9) + '.' + value.slice(9, 13) + '.8.11.' + value.slice(13, 20);
          } else if (value.length > 9) {
            value = value.slice(0, 7) + '-' + value.slice(7, 9) + '.' + value.slice(9, 13);
          } else if (value.length > 7) {
            value = value.slice(0, 7) + '-' + value.slice(7,);
          }
          this.numeroProcesso = value;
        },
        acionarModalAdicionarNumeroProcesso() {
          this.modalAdicionarNumeroProcesso = !this.modalAdicionarNumeroProcesso;
        },
        adicionarNumeroProcesso() {
          if (this.numeroProcesso === null) {
            this.$toast.add({
              severity: "error",
              summary: "Obrigatório o número do processo.",
              life: 3000,
            });
          }
          const numero = this.numeroProcesso;
          this.listaNumeroProcesso.push({indice: this.listaNumeroProcesso.length, numero: numero});
          this.numeroProcesso = null;
          this.acionarModalAdicionarNumeroProcesso();
        },
        removerNumeroProcesso(indice) {
          this.listaNumeroProcesso = this.listaNumeroProcesso.filter(obj => obj.indice !== indice);
        },
        descreverDesconto() {
          this.descricaoPercentage = this.percentage + "% de desconto do advogado mais " + this.registro.descDespacho;
        },
        formatPercentage(value) {
          return `${value}%`;
        },
        parsePercentage(value) {
          return value.replace('%', '');
        },
        validatePercentage(value) {
          if (value === 0) this.percentage = 1;
          if (value > 50) this.percentage = 50;
          this.descreverDesconto()
        },
        carregarDados(){
            let query = this.$route.query;   
            if(query.id){    
                this.idenSolicitacao = query.id;                             
                this.$http.get(`${baseApiUrl}/solicitacoes-verba-rescisoria/${query.id}`).then((res) => {
                    this.solicitacaoVerbaRec = res.data 
                    if(res.data.solicitacaoVerbaProcessoList.length > 0){
                        this.solicitacaoVerbaRec.flagPossuiProcesso = "1"
                    }else{
                        this.solicitacaoVerbaRec.flagPossuiProcesso = "0"
                    }
                    this.dadosPessoa = {
                        matricula:  this.$store.getters.getMatricula,
                        vinculo: this.$store.getters.getVinculo,
                        cpf: this.$store.getters.getUser.dadosUsuariosCustomizados.pessoa.documentosPessoais.cpf,
                        rg: this.$store.getters.getUser.dadosUsuariosCustomizados.pessoa.documentosPessoais.rg,
                        nome: this.$store.getters.getUser.dadosUsuariosCustomizados.pessoa.nome,
                        cpfFormatado: this.$store.getters.getUser.dadosUsuariosCustomizados.pessoa.documentosPessoais.cpfFormatado,
                    };
                    if(res.data.statAndamento!='PROPOSTA_EMITIDA'){                        
                        this.$toast.add({
                        severity: "error",
                        summary:
                            "Não é permitido Acesso sem Solicitação selecionada. Proposta já aceita.",
                        life: 3000,
                        });
                        this.voltarParaLista();
                    }
                    let valorInicial = 0
                    this.listaValorCalculado = res.data.solicitacaoValorVinculoList.map(function(elemento){
                        if(elemento.flagUtilizado == 'S'){
                            valorInicial = valorInicial+elemento.valorTotalCorrigido
                        }
                        return {
                            ...elemento,
                            valorTotalEfetivo: elemento.valorTotalEfetivo!=null? elemento.valorTotalEfetivo: elemento.valorTotalDevido?  elemento.valorTotalDevido : 0
                        }
                    })

                    this.listaValorCalculado = this.listaValorCalculado.filter(function(elemento){
                        return elemento.flagUtilizado === 'S'
                    })

                    this.valorCalculadoFinal = valorInicial;

                    if(res.data.solicitacaoDespachoList.length > 0){
                        this.registro = res.data.solicitacaoDespachoList[0]                           
                        this.$http.get(`${baseApiUrl}/despachos/propostas/solicitacao/${this.solicitacaoVerbaRec.idenSolicitacaoVerbaResc}`).then((res2) => {
                            this.listaPropostaDespacho = res2.data.sort(function(a, b) {
                                return a.valrDespachoPro - b.valrDespachoPro; 
                            });
                        })                    

                    }

                    this.$http.get(`${baseApiUrl}/dados-bancarios/${res.data.numrMatricula}`).then((res2) => {
                        this.dadosBancarios = res2.data
                    })    
                    
                });
            }else{
                this.$toast.add({
                severity: "error",
                summary:
                    "Não é permitido Acesso sem Solicitação selecionada.",
                life: 3000,
                });
            }
        },
        voltarParaLista(){
            this.$router.push({name:"solicitaVerba"});
        },
        fecharModal(){
            this.visualizarModalAceito = false;
            this.visualizarModalRecusa = false;
        },    
        aceitarValores(data){    
            if(this.propostaSelecionada != null){  
                this.valorselecionado = data;
                if (this.possuiAdvogado) {
                  if (this.percentage == null) {
                    this.$toast.add({
                      severity: "error",
                      summary:
                          "É necessário colocar a porcentagem de desconto do advogado.",
                      life: 3000,
                    });
                    return;
                  }
                  this.descontoAdvogado = this.propostaSelecionada.valrDespachoPro * this.percentage / 100;
                  this.valorComDescontoAdvogado = this.propostaSelecionada.valrDespachoPro - this.descontoAdvogado;
                }
                this.visualizarModalAceito = true;
            }else{                
                this.$toast.add({
                severity: "error",
                summary:
                    "É necessário selecionar uma proposta para Aceitar o Acordo",
                life: 3000,
                });
            }
        },
        aceitarProposta(){    
            if(this.propostaSelecionada != null){        
                if(this.login != '' && this.senha != ''){
                    let jsonBody;
                    if (this.possuiAdvogado) {
                      jsonBody = {
                        idenSolicitacaoDespachoProposta: this.propostaSelecionada.idenSolicitacaoDespachoPro,
                        idenSolicitacaoVerbaRescisoria:  this.idenSolicitacao,
                        username: this.login,
                        password: this.senha,
                        porcentagemDeDesconto: this.percentage,
                        listaNumeroProcesso: this.listaNumeroProcesso.map(obj => obj.numero)
                      }
                    } else {
                      jsonBody = {
                        idenSolicitacaoDespachoProposta: this.propostaSelecionada.idenSolicitacaoDespachoPro,
                        idenSolicitacaoVerbaRescisoria:  this.idenSolicitacao,
                        username: this.login,
                        password: this.senha,
                      }
                    }
                    this.$http.post(`${baseApiUrl}/despachos/propostas/aceitar-proposta`, JSON.stringify(jsonBody)).then(() => {      
                        this.$toast.add({
                            severity: "success",
                            summary:
                                "Acordo Aceito e Assinado Com Sucesso",
                            life: 3000,
                        });   
                        this.voltarParaLista();
                    })

                }else{                  
                    this.$toast.add({
                        severity: "error",
                        summary:
                            "É necessário preencher o Login ou a Senha para Assinar o Acordo",
                        life: 3000,
                    });                    
                }
            }else{                        
                this.$toast.add({
                severity: "error",
                summary:
                    "É necessário selecionar uma proposta para Aceitar o Acordo",
                life: 3000,
                });
            }
            this.fecharModal()
            
        },
        recurarValores(){
            this.visualizarModalRecusa = true;
        },
        recusarProposta(){
            if(this.login != '' && this.senha != ''){
                let jsonBody = { 
                    idenSolicitacaoVerbaRescisoria:  this.idenSolicitacao,
                    username: this.login,
                    password: this.senha

                }
                this.$http.post(`${baseApiUrl}/despachos/propostas/negar-proposta`, JSON.stringify(jsonBody)).then(() => {      
                    this.$toast.add({
                        severity: "success",
                        summary:
                            "Acordo Recusado e Assinado Com Sucesso",
                        life: 3000,
                    });   
                    this.voltarParaLista();
                })

            }else{                  
                this.$toast.add({
                    severity: "error",
                    summary:
                        "É necessário preencher o Login ou a Senha para Assinar a Recusa",
                    life: 3000,
                });                    
            }            
        },
        buscaMotivo(code){
            let name = "";
            for(let i=0; i<this.listaMotivo.length; i++ ){
                if(this.listaMotivo[i].code == code){
                    name = this.listaMotivo[i].name
                    break;
                }   
            }
            return name;
        },
        abrirRelatorioCalculo() {
            this.$http
            .get(`${baseApiUrl}/relatorios/verbarescisoria/calculo-valor-total/${this.solicitacaoVerbaRec.idenSolicitacaoVerbaResc}`)
            .then((res) => {
            this.pdfElement = res.data.dadosRelatorioBase64;
            this.nomeDocumentoPDF = res.data.nomeArquivo;
            this.exibirPDF = true;

            const byteCharacters = atob(res.data.dadosRelatorioBase64);
            const byteNumbers = new Array(byteCharacters.length);

            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: "application/pdf" });

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(blob, "Acordo.pdf");
            } else {
                const objectUrl = URL.createObjectURL(blob);

                const link = document.createElement("a");
                link.href = objectUrl;
                link.download = "Acordo.pdf";
                link.style.display = "none";

                if (this.detectaNavegador() === 4) {
                this.exibirPDF = false;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                setTimeout(() => {
                    window.open(objectUrl, "_blank");
                }, 1000);
                }

                setTimeout(() => {
                URL.revokeObjectURL(objectUrl);
                }, 2000);
            }
            });
        },
    },
    mounted() {
        this.carregarDados();
    },

}
</script>

<style scoped>
    .textoInformativoVerbaIdenizatoriaForm{
        line-height: 1.5;
        margin: 0;
        text-align: justify;
    }
    .iconIdentificacaoForm {
        font-size: 8em;
    }
    .divRadioButton{
        display: flex;
        flex-direction: row;
        align-items: center;
    }
    .divBotoesFinais{
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
    }
    .p-dialog-content{
        overflow-y: hidden !important;
    }
</style>